module.exports = __webpack_public_path__ + "img/图片3.deb3bec6.png";